<div class="row d-flex justify-content-between">
    <div class="input-group input-group-sm  mb-2 item d-flex justify-content-start">
    </div>
    <div class="input-group input-group-sm mb-2 item add-item">
        <div class="input-group-append">
            <button class="btn btn-app" type="button" (click)='saveItem()'>
                <i class="fas fa-save"></i>
                Salva
            </button>
        </div>
    </div>
</div>

<div class="pr-3 pl-3 mb-5">
    <div class="table-responsive">
        <table class="table table-hover table-sm table-edit" id="defaultCheck1">
            <thead class="thead-default">
                <tr>
                    <th scope="col" class="col-3">Descrizione</th>
                    <th scope="col" class="col-9">Valore</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>ID</td>
                    <td>
                        <input class="form-control form-control-sm" type="number" [(ngModel)]="single['id']" id="id" disabled>
                    </td>
                </tr>
                <tr>
                    <td>Descrizione</td>
                    <td>
                        <input class="form-control form-control-sm" [(ngModel)]="single['description']" id="description">
                    </td>
                </tr>
                <tr>
                    <td>base64</td>
                    <td>
                        <input class="form-control form-control-sm" [(ngModel)]="single['base64']" id="crestUrl" disabled>
                    </td>
                </tr>
                <tr>
                    <td>
                        Master
                    </td>
                    <td>
                        <div class="checkbox-container">
                            <div class="checkbox-group">
                                <label>
                                    <input class="form-check-input form-check-input-sm" 
                                           type="checkbox" 
                                           [checked]="single['master'] == 1"
                                           (change)="single['master'] = $event.target.checked ? 1 : 0">
                                    Master
                                </label>
                            </div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td>Gruppo</td>
                    <td>
                        <!-- <select class="form-select" id="inputGroupSelect01" [(ngModel)]="single['group_id']">
                            <option value="0">Crea un nuovo gruppo</option>
                            <option *ngFor="let grp of groupid_list" [value]="grp.group_id" >
                                {{grp.group_id}}
                            </option>  
                        </select> -->
                        <input class="form-control form-control-sm" [(ngModel)]="single['group_id']" >
                    </td>
                </tr>
                <tr>
                    <td>Tipo</td>
                    <td>
                        <select class="form-select" id="inputGroupSelect01" [(ngModel)]="single['cresttype_id']">
                            <option value="0">Scegli il tipo</option>
                            <option *ngFor="let ct of cresttype_id_list" [value]="ct.id" >
                                {{ct.description}}
                            </option>   
                        </select>
                    </td>
                </tr>

            </tbody>
        </table>
    </div>
        <div class="file-upload" *ngIf="single['id'] == 0">
            <div class="fileZone" 
                 (click)="fileInput.click()"
                 (dragover)="onDragOver($event)"
                 (dragleave)="onDragLeave($event)"
                 (drop)="onDrop($event)"
                 [ngClass]="{'isDragging': isDragging}">
              <i class="fas fa-file-import fa-fw"></i>
              <p>Trascina qui il tuo file</p>
              <p>.svg</p>
              <p>oppure</p>
              <button type="button">Cerca il tuo file</button>
              <input type="file" #fileInput (change)="onFileSelected($event)" accept=".svg" hidden />
            </div>
          
            <div *ngIf="selectedFileName" class="file-info">
              <span>{{ selectedFileName }}</span>
              <button class="remove-button" (click)="removeFile()">✕</button>
            </div>
        </div>
</div>


<app-alertbox #alertbox1 [alerts]=""></app-alertbox>